// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"8904ba73","442":"8904ba73","609":"8904ba73"}[chunkId] + ".chunk.css";
};